import React, { Fragment } from 'react';
import theme from './ChangeRequestOverviewUnitItem.module.scss';
import { ChangeRequestOverview, ChangeRequestOverviewParticipant } from '@/types';
import { SimpleCard, CardSection } from '@/components/Cards';
import { Trans } from '@lingui/react/macro';
import { UserIcon } from '@/components/Icons';
import Indicator, { IndicatorColor } from '@/components/Indicator';
import { classnames } from '@/utils/html';
import { ProjectRelativeLink } from '@/components/navigation';

interface ChangeRequestOverViewItemProps {
    changeRequest: ChangeRequestOverview;
}

const ChangeRequestOverviewUnitItem: React.FC<ChangeRequestOverViewItemProps> = ({ changeRequest }) => {
    const renderStatus = (participant: ChangeRequestOverviewParticipant, isLast: boolean) => {
        let label = <Trans>No offer</Trans>;
        let color: IndicatorColor = 'danger';

        if (participant.sentOffer) {
            label = <Trans>Offer sent</Trans>;
            color = 'success';
        }
        return (
            <Indicator className={classnames(theme.indicator, { [theme.last]: isLast })} color={color}>
                {label}
            </Indicator>
        );
    };
    return (
        <SimpleCard>
            <CardSection grow contentClassName={theme.left} caption={<Trans>Request</Trans>}>
                <ProjectRelativeLink className={theme.requestLink} to={`/changes/${changeRequest.changeRequestId}`}>
                    {changeRequest.subject}
                </ProjectRelativeLink>
                <span>{changeRequest.description}</span>
            </CardSection>
            <div className={theme.borderContainer}>
                {changeRequest.participants.map((p, i) => (
                    <Fragment key={p.userId}>
                        <div className={theme.participants}>
                            <div
                                className={classnames(theme.participantRow, {
                                    [theme.last]: i === changeRequest.participants.length - 1,
                                })}>
                                <UserIcon sizeInPx={25} userId={p.userId} />
                                <div className={theme.textContainer}>
                                    <strong>{p.displayName}</strong>
                                    <span className={theme.profileName}> {p.profileName}</span>
                                </div>
                            </div>
                            {renderStatus(p, i === changeRequest.participants.length - 1)}
                        </div>
                        {i !== changeRequest.participants.length - 1 && <div className={theme.border} />}
                    </Fragment>
                ))}
                {changeRequest.participants.length === 0 && (
                    <div className={theme.noParticipants}>
                        <Trans>This change request has not been assigned yet</Trans>
                    </div>
                )}
            </div>
        </SimpleCard>
    );
};

export default ChangeRequestOverviewUnitItem;
